module.exports = __webpack_public_path__ + "static/media/Pale_Blue_Dot.58cffbbe.png";